import React, { useEffect } from 'react';
import { Brandbar, Footer, Metabar } from '@lsg/components';

import './CustomFooter.css';
import { SocialMediaDropdown } from './SocialMediaDropdown';
import { socialMediaData } from './socialMediaData';

const CustomFooter = () => {
    const navigationTree = [
        {
            label: 'Terms and Conditions',
            href: '/terms-and-conditions',
        },
        {
            label: 'Privacy Policy',
            href: '/privacy-policy',
        },
        {
            label: 'Imprint',
            href: '/imprint',
        },
        {
            label: 'Cookie Preferences',
            id: '#cookiePrefs',
            href: '/',
        },
    ];

    useEffect(() => {
        const cookieElement = document.getElementById('#cookiePrefs');
        cookieElement.addEventListener('click', function () {
            localStorage.removeItem('analyticsConsent');
        });
    }, []);

    return (
        <Footer>
            <Brandbar
                href="https://www.commerzbank.de/"
                slogan="COLLABOTHON 2023"
                logoHtmlAttrs={{ target: '_blank', rel: 'noopener noreferrer' }}
            />
            <Metabar
                navigationTree={navigationTree}
                socialLinks={
                    <div key={'social-media-links'}>
                        <span
                            key={'intro'}
                            className={'links-intro'}
                        >
                            Follow us online:
                        </span>
                        <SocialMediaDropdown
                            key={socialMediaData[0].name}
                            data={socialMediaData[0]}
                        />
                        <SocialMediaDropdown
                            key={socialMediaData[1].name}
                            data={socialMediaData[1]}
                        />
                        <SocialMediaDropdown
                            key={socialMediaData[2].name}
                            data={socialMediaData[2]}
                        />
                        <SocialMediaDropdown
                            key={socialMediaData[3].name}
                            data={socialMediaData[3]}
                        />
                    </div>
                }
            />
        </Footer>
    );
};
export default CustomFooter;
